import alloyAnalytics from '@telus/alloy-analytics'

const NAME = 'smart_energy_calculator'
const TOOL_NAME = 'smart_energy_calculator_v2'
const TOOL_TYPE = 'calculator'
const TYPE = 'other'

const formatKey = (key: string): string => {
  return key.replace(/ /g, '_').toLowerCase()
}
const transformCounts = (counts: Record<string, number>): string => {
  let countString = ''
  const keys = Object.keys(counts)
  keys.forEach((key, index) => {
    countString += `${formatKey(key)}:${counts[key]}`
    if (index < keys.length - 1) {
      countString += ','
    }
  })
  return countString
}

const alloyEvents = {
  toolStart: (url: URL['href']) => {
    const toolStart = {
      name: NAME,
      toolName: TOOL_NAME,
      toolType: TOOL_TYPE,
      type: TYPE,
      URL: url,
    }
    alloyAnalytics.event('toolStart').webInteraction(toolStart).fire()
  },
  toolStep: (province: string, liveIn: string, heating: string, url: URL['href']) => {
    const toolStep = {
      name: NAME,
      toolName: TOOL_NAME,
      toolType: TOOL_TYPE,
      toolSelections: `province:${province},type:${liveIn},heating:${heating}`,
      toolUsageStepName: 'smart_energy_calculator_step_1',
      type: TYPE,
      URL: url,
    }
    alloyAnalytics.event('toolStep').webInteraction(toolStep).fire()
  },
  toolComplete: (counts: Record<string, number>, url: URL['href'], totalSavingsValue: string) => {
    const toolStep = {
      name: NAME,
      toolName: TOOL_NAME,
      toolType: TOOL_TYPE,
      type: TYPE,
      URL: url,
      toolSelections: transformCounts(counts),
      smartEnergyCalcSave: Number(totalSavingsValue),
    }
    alloyAnalytics.event('toolComplete').webInteraction(toolStep).fire()
  },
}

export default alloyEvents
